import React, { useState, useEffect } from "react";
import "./Jobs.css";
import { useDispatch, useSelector } from "react-redux";
import {
  allJobs,
  setAllJobsData,
} from "../../../Redux/Slices/Pages/Jobs/JobsSlice";
import JobCard from "../../../Components/Card/JobsCard/JobCard";
import Proposel from "../Components/Proposel";

const Jobs = () => {
  const dispatch = useDispatch();

  const [selectedJob, setSelectedJob] = useState(null);
  const jobsPostsInfo = useSelector((state) => state.jobs.allJobsData);
  const openRequestModal = (jobData) => {
    setSelectedJob(jobData);
  };

  const closeRequestModal = () => {
    setSelectedJob(null);
  };

  useEffect(() => {
    dispatch(allJobs());
    return () => {
      dispatch(setAllJobsData([]));
    };
  }, []);

  return (
    <div className=" pt-10   bg-gradient-to-br from-slate-900 via-blue-700 to-slate-900">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mx-5">
        {jobsPostsInfo?.map((post) => (
          <JobCard
            jobData={post}
            onSendProposal={() => openRequestModal(post)}
          />
        ))}
      </div>

      {selectedJob && (
        <Proposel
          selectedJob={selectedJob}
          closeRequestModal={closeRequestModal}
        />
      )}
    </div>
  );
};

export default Jobs;
